// src/pages/AdminDashboard.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Base URL for the Courses API
const API_URL = 'http://localhost:5000/courses/add'; 

const AdminDashboard = () => {
    const navigate = useNavigate();
    // State for the form inputs
    const [title, setTitle] = useState(''); // Corrected to 'title' to match backend model
    const [courseCode, setCourseCode] = useState('');
    const [credits, setCredits] = useState(''); // Added required field
    const [department, setDepartment] = useState(''); // Added required field
    
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    // Function to handle the logout process
    const handleLogout = () => {
        // 1. CRITICAL: Use the correct token key 'authToken'
        localStorage.removeItem('authToken');
        // 2. CRITICAL: Remove the user role too
        localStorage.removeItem('userRole'); 
        
        // Redirect the user back to the login page
        navigate('/login');
    };

    // The protected API call function
    const addCourse = async (courseData) => {
        // CRITICAL: Use the correct token key 'authToken'
        const token = localStorage.getItem('authToken'); 
        setLoading(true);
        setMessage('');

        try {
            const res = await axios.post(API_URL, courseData, {
                headers: {
                    'Authorization': `Bearer ${token}` // Attach the JWT
                }
            });
            
            // Check for success message from backend response body
            setMessage(res.data.message || 'Course added successfully!');
            
            // Clear form fields on success
            setTitle(''); 
            setCourseCode('');
            setCredits('');
            setDepartment('');
            
        } catch (err) {
            console.error('Failed to add course:', err.response || err);
            
            // Extract specific error message from backend
            const backendMessage = err.response?.data?.message;

            // Handle Unauthorized error (401: Token expired or invalid)
            if (err.response && err.response.status === 401 || err.response.status === 403) {
                alert('Your session has expired or you are not authorized. Please log in again.');
                handleLogout(); // Log the user out
            } else if (backendMessage) {
                // Show specific validation/data error from the backend
                setMessage(`Error: ${backendMessage}`);
            } 
            else {
                setMessage('An unknown error occurred while adding the course.');
            }
        } finally {
            setLoading(false);
        }
    };

    // Form submission handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // CRITICAL: The data object MUST match the required backend schema fields
        const newCourse = { 
            title, 
            courseCode,
            credits: parseInt(credits, 10), // Ensure credits is sent as a number
            department,
            // durationYears is optional, so we omit it here
        };
        
        // Basic frontend validation for required fields
        if (!title || !courseCode || !credits || !department) {
             setMessage('Please fill in all required fields (Name, Code, Credits, Department).');
             return;
        }

        await addCourse(newCourse);
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>Admin Dashboard</h2>
            <p>Welcome to the admin panel. Manage your website's content here.</p>

            {/* Logout Button */}
            <button onClick={handleLogout} style={{ position: 'absolute', top: '20px', right: '20px' }}>
                Logout
            </button>
            
            {/* Display Admin Links */}
            <div style={{ marginBottom: '20px', display: 'flex', gap: '15px' }}>
                {/* Use the router links to navigate to other management pages */}
                <button onClick={() => navigate('/admin/gallery')}>Manage Gallery</button>
                {/* <button onClick={() => navigate('/admin/admissions')}>Manage Admissions</button> */}
                {/* Add links for Alumni, Feedback View, etc. */}
            </div>

            {/* Form for adding a new course */}
            <div style={{ marginTop: '20px', border: '1px solid #ccc', padding: '20px', borderRadius: '8px' }}>
                <h3>Add New Course</h3>
                <form onSubmit={handleSubmit}>
                    {/* Course Name (Title) */}
                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ display: 'block' }}>Course Name (Title):</label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>
                    {/* Course Code */}
                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ display: 'block' }}>Course Code:</label>
                        <input
                            type="text"
                            value={courseCode}
                            onChange={(e) => setCourseCode(e.target.value)}
                            required
                        />
                    </div>
                    {/* Credits */}
                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ display: 'block' }}>Credits:</label>
                        <input
                            type="number"
                            value={credits}
                            onChange={(e) => setCredits(e.target.value)}
                            required
                            min="1"
                        />
                    </div>
                    {/* Department */}
                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ display: 'block' }}>Department:</label>
                        <input
                            type="text"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                            required
                        />
                    </div>
                    
                    <button type="submit" disabled={loading}>
                        {loading ? 'Adding...' : 'Add Course'}
                    </button>
                </form>
                {message && <p style={{ marginTop: '10px', color: message.includes('successfully') ? 'green' : 'red' }}>{message}</p>}
            </div>

            {/* You would add more forms and content management sections here */}
        </div>
    );
};

export default AdminDashboard;